import request from '../http.js'


class Exam{
    startExam(data) {
        return request.post('/exam/start', data)
    }
    getExamDetail(data) {
        return request.post('/exam/detail', data)
    }
    getExamInformationList(data) {
        return request.post('/exam/information', data)
    }
    finishExam(data) {
        return request.post('/exam/finish', data)
    }
    continueExam(data) {
        return request.post('/exam/continue',data)
    }
    stopExam(data) {
        return request.post('/exam/stop',data)
    }
    deleteExam(data) {    //用户在没点击选项情况下强行退出模考调用此接口。
        return request.post('/exam/delete',data)
    }
}



export default new Exam()